export const policyData = [
  {
    title: "1. About Us",
    content: (
      <>
        <p className="mb-3">
          We, Brandlogs Inc., a Delaware Corporation with offices in 4 Palo Alto
          Square, 3000 El Camino Real Building, 94306, CA ("Brandlogs"), are
          committed to protecting any data that we collect concerning you. By
          using our services, you agree to the use of the data that we collect
          following this Privacy Policy.
        </p>
        <p className="mb-3">
          Brandlogs offers a community Web platform leveraging peer-to-peer
          e-gifting during birthday celebrations to guarantee recurring hunger
          donations to ensure no child goes to Bed Hungry when users like you
          and me enjoy:
        </p>
        <ul className="list-disc pl-5 mb-3">
          <li>Celebrating birthdays</li>
          <li>Gifting friends and family</li>
          <li>Connecting with brands</li>
          <li>Sharing experiences</li>
        </ul>
        <p className="mb-3">
          Brandlogs was established with the core mission of ending hunger in
          America and beyond! By unlocking new gifting possibilities to
          guarantee recurring hunger donations to feed food-insecure families.
        </p>
        <p className="mb-3">
          According to the UN, over 733 million people globally faced hunger in
          2023—equivalent to one in every eleven people. This issue highlights
          the importance of the movement led by Brandlogs to combat food
          insecurity worldwide.
        </p>
      </>
    ),
  },
  {
    title: "2. Information Collected",
    content: (
      <>
        <p className="mb-3">
          We collect the following types of information from you to provide you
          with the products and services you purchased and for the purposes
          described below. We may collect any or all of the information via both
          automated means, such as cookies, or through communications profiles.
        </p>
        <h4 className="font-semibold text-lg mb-2">
          Information and Content You Provide
        </h4>
        <p className="mb-3">
          We collect the content, communications, and other information you
          provide when you use our platform and products. This includes your
          name, address, email, and other personal details provided during your
          interactions on our platform.
        </p>
        <h4 className="font-semibold text-lg mb-2">Networks and Connections</h4>
        <p className="mb-3">
          We collect information about the pages, accounts, and hashtags of
          brands that you are connected to and how you interact with them across
          our products.
        </p>
        <h4 className="font-semibold text-lg mb-2">
          Information About Transactions
        </h4>
        <p className="mb-3">
          If you use our products for purchases or other financial transactions,
          we collect information about the purchase or transaction. This
          includes payment information, account authentication, and billing
          details.
        </p>
        <h4 className="font-semibold text-lg mb-2">Cookies and Tracking</h4>
        <p className="mb-3">
          Your Internet browser has the built-in facility for storing small text
          files—"cookies"—that hold information allowing a website to recognize
          your account. We use cookies for personalized functionality,
          statistical purposes, and to improve our products and services.
        </p>
        <h4 className="font-semibold text-lg mb-2">Customer Surveys</h4>
        <p className="mb-3">
          We may periodically conduct customer surveys to collect feedback that
          helps improve our products. Participation is voluntary, and your
          responses are kept confidential.
        </p>
      </>
    ),
  },
  {
    title: "3. Information Use",
    content: (
      <>
        <p className="mb-3">
          We use the information we have (subject to the choices you make) to
          provide and support our products and related services.
        </p>
        <h4 className="font-semibold text-lg mb-2">
          Provide, Personalize, and Improve Our Products
        </h4>
        <p className="mb-3">
          We use the information to deliver our products, personalize features
          and content, and make suggestions for you based on your preferences
          and activities.
        </p>
        <h4 className="font-semibold text-lg mb-2">
          Promote Safety and Security
        </h4>
        <p className="mb-3">
          We use your information to verify accounts, detect and prevent harmful
          conduct, and promote safety and security across our platform.
        </p>
        <h4 className="font-semibold text-lg mb-2">Communicate with You</h4>
        <p className="mb-3">
          We use the information to send marketing communications, respond to
          inquiries, and provide updates about our products and services.
        </p>
      </>
    ),
  },
  {
    title: "4. Disclosing Information",
    content: (
      <>
        <p className="mb-3">
          Your information is shared with others in the following ways:
        </p>
        <h4 className="font-semibold text-lg mb-2">
          Sharing on the Brandlogs Platform
        </h4>
        <p className="mb-3">
          Information may be shared with people and accounts you interact with,
          such as brands or other users.
        </p>
        <h4 className="font-semibold text-lg mb-2">Third-Party Partners</h4>
        <p className="mb-3">
          We work with third-party partners who help us provide and improve our
          products, but we impose strict restrictions on how they can use the
          information we share.
        </p>
        <h4 className="font-semibold text-lg mb-2">Law Enforcement</h4>
        <p className="mb-3">
          We may disclose information in response to valid legal requests or to
          prevent illegal or unethical activities.
        </p>
      </>
    ),
  },
  {
    title: "5. Your Options",
    content: (
      <>
        <h4 className="font-semibold text-lg mb-2">
          Correcting or Updating Information
        </h4>
        <p className="mb-3">
          If your information changes, you can contact us to correct or update
          it.
        </p>
        <h4 className="font-semibold text-lg mb-2">Opt-Out</h4>
        <p className="mb-3">
          You can opt out of newsletters or promotional emails, but you may
          still receive important system notifications.
        </p>
        <h4 className="font-semibold text-lg mb-2">Public Forums</h4>
        <p className="mb-3">
          Information shared in public forums may be visible to others. Contact
          us to request removal of your data from such areas if needed.
        </p>
      </>
    ),
  },
  {
    title: "6. Data Security",
    content: (
      <>
        <p className="mb-3">
          We implement technical and managerial measures to safeguard your
          information, including encryption and secure servers.
        </p>
      </>
    ),
  },
  {
    title: "7. Children",
    content: (
      <>
        <p className="mb-3">
          Our website is not directed towards children under the age of 13. If
          we become aware of data collection from a child, we will delete it
          promptly.
        </p>
      </>
    ),
  },
  {
    title: "8. Reseller Relationships",
    content: (
      <>
        <p className="mb-3">
          For reseller relationships, Brandlogs collects and retains data under
          the direction of the reseller. Customers seeking data updates should
          contact the reseller directly.
        </p>
      </>
    ),
  },
  {
    title: "9. Changes to This Policy",
    content: (
      <>
        <p className="mb-3">
          We reserve the right to revise this Privacy Policy at any time.
          Significant changes will be communicated before they take effect.
        </p>
      </>
    ),
  },
];
